import {useContext} from 'react';
import {AuthContextState, IAuthContext} from '../context/AuthContext';
import {ISubscriptionContext, SubscriptionContextState} from "../context/SubscriptionContext";

export const useSubscription = () => useContext<SubscriptionContextState>(ISubscriptionContext)